<template>
    <div class="bg-[#66A3FF14] text-white overflow-hidden rounded-xl border border-[#FFFFFF1F] p-4">
        <div class="flex gap-2">
            <!-- Product Images Carousel -->
            <Carousel :value="products" :numVisible="1" :numScroll="1" :show-navigators="false" :show-indicators="false"
                circular :pt="{ indicator: { class: '!rounded-full' } }" class="!w-56 -mt-14">
                <template #item="slotProps">
                    <NuxtImg :src="slotProps.data.image" width="180" height="200" class="rounded-md max-h-[200px]"
                        alt="product image" loading="lazy" />
                </template>
            </Carousel>

            <!-- Product Info -->
            <div class="space-y-2 flex-1">
                <div>
                    <h2 class="text-lg font-semibold text-[var(--text-secondary)]">
                        {{ currentProduct?.name }}
                    </h2>
                </div>

                <div class="text-xs text[var(--text-secondary)] font-bold text-foreground">
                    {{ currentProduct?.price }}
                </div>

                <Button unstyled label="SHOP NOW" iconPos="right"
                    class="!rounded-lg !px-5 !bg-[var(--background-btn)] !py-3 !text-xs !font-semibold !text-[var(--text-secondary)] !flex !items-center !gap-3">
                    <template #icon>
                        <i class="pi pi-arrow-right font-bold !text-xs"></i>
                    </template>
                </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

interface Product {
    id: number
    name: string
    model: string
    price: string
    image: string
}

const products: Product[] = [
    {
        id: 1,
        name: "Sony New ULT Wear",
        model: "WH-ULT900N",
        price: "$189 USD",
        image: "/images/product-showcase/headphone.png",
    },
    {
        id: 2,
        name: "Sony WH-1000XM5",
        model: "Premium Noise Canceling",
        price: "$399 USD",
        image: "/images/product-showcase/headphone.png",
    },
    {
        id: 3,
        name: "Sony WF-1000XM4",
        model: "True Wireless Earbuds",
        price: "$279 USD",
        image: "/images/product-showcase/headphone.png",
    },
]

const currentIndex = ref(0)
const currentProduct = computed(() => products[currentIndex.value])
</script>
